import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  AdminContainer,
  AdminHeader,
  TabContainer,
  Tab,
  AdminContent,
  MobileSelect,
} from "../styles";
import {
  Spinner,
  AppointmentTabs,
} from "../components";
import { getUser } from "../api";

const WorkerPanel = () => {
  const [activeTab, setActiveTab] = useState("bookingHistory");
  const [checkingAuth, setCheckingAuth] = useState(false);        

  const navigate = useNavigate();

  const tabs = [
    { key: "bookingHistory", label: "Histórico de Marcações" },
  ];

  const activeContent = useMemo(() => {
    switch (activeTab) {
      case "bookingHistory":
        return <AppointmentTabs />;
      default:
        return null;
    }
  }, [activeTab]);

  useEffect(() => {
    const validateToken = async () => {
      try {
        setCheckingAuth(true);

        const response = await getUser();

        if (!response.ok) {
          throw new Error("Token inválido ou expirado.");
        }

        const data = await response.json();

        if (data.userRole !== 'worker') {
          throw new Error("Usuário não é trabalhador.");
        }

      } catch (error) {
        console.log('Erro ao validar token: ', error);
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      } finally {
        setCheckingAuth(false);
      }
    };

    validateToken();
  }, [activeTab, navigate]);

  if (checkingAuth) {
    return <Spinner />;
  }

  return (
    <AdminContainer>
      <AdminHeader>Painel do Trabalhador</AdminHeader>

      {/* Tabs para Desktop */}
      <TabContainer>
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            active={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabContainer>

      {/* Select Dropdown para Mobile */}
      <MobileSelect
        value={activeTab}
        onChange={(e) => setActiveTab(e.target.value)}
      >
        {tabs.map((tab) => (
          <option key={tab.key} value={tab.key}>
            {tab.label}
          </option>
        ))}
      </MobileSelect>

      {/* Renderiza o conteúdo da aba ativa */}
      <AdminContent>
        {activeContent}
      </AdminContent>
    </AdminContainer>
  );
};

export default WorkerPanel;
